"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const events_1 = require("events");
const events_2 = require("../const/events");
const INTERNAL_ALL_EVENTS = "__INTERNAL_ALL_EVENTS__";
class Channel {
    constructor(channelName, liquidTap, subPayload) {
        this.subscriptionAttempted = false;
        this.subscriptionPending = false;
        this.subscriptionCancelled = false;
        this.subscribed = false;
        this.unsubscribed = false;
        this.name = channelName;
        this.liquidTap = liquidTap;
        this.subPayload = subPayload;
        this.eventEmitter = new events_1.EventEmitter();
        this.subscriptionAttempted = false;
        this.subscriptionPending = false;
        this.subscriptionCancelled = false;
        this.subscribed = false;
        this.unsubscribed = false;
        this.stats = {
            received: 0,
            sent: 0,
        };
    }
    /* ----------- PUBLIC ----------- */
    notify(wsEvent) {
        switch (wsEvent.event) {
            case events_2.SERVER_EVENTS.DOWN.SUBSCRIPTION_SUCCEEDED:
                this.subscriptionPending = false;
                this.subscribed = true;
                this.eventEmitter.emit(events_2.CLIENT_EVENTS.SUBSCRIPTION_SUCCEEDED, wsEvent.data);
                break;
            case events_2.SERVER_EVENTS.DOWN.SUBSCRIPTION_FAILED:
                this.subscriptionPending = false;
                this.subscribed = false;
                this.eventEmitter.emit(events_2.CLIENT_EVENTS.SUBSCRIPTION_FAILED, wsEvent.data);
                break;
            default:
                this.stats.received += 1;
                this.eventEmitter.emit(wsEvent.event, wsEvent.data);
                this.eventEmitter.emit(INTERNAL_ALL_EVENTS, wsEvent);
                break;
        }
    }
    onSubscribed(handler) {
        if (handler !== undefined) {
            if (this.subscribed) {
                return handler(events_2.CLIENT_EVENTS.SUBSCRIPTION_SUCCEEDED);
            }
            if (this.subscriptionAttempted) {
                return handler(events_2.CLIENT_EVENTS.SUBSCRIPTION_FAILED);
            }
            this.eventEmitter.on(events_2.CLIENT_EVENTS.SUBSCRIPTION_SUCCEEDED, () => handler(events_2.CLIENT_EVENTS.SUBSCRIPTION_SUCCEEDED));
            this.eventEmitter.on(events_2.CLIENT_EVENTS.SUBSCRIPTION_FAILED, () => handler(events_2.CLIENT_EVENTS.SUBSCRIPTION_FAILED));
            return;
        }
        if (this.subscribed) {
            return Promise.resolve();
        }
        if (this.subscriptionAttempted) {
            return Promise.reject(new Error("Subscription Failed"));
        }
        return new Promise((resolve, reject) => {
            this.eventEmitter.on(events_2.CLIENT_EVENTS.SUBSCRIPTION_SUCCEEDED, resolve);
            this.eventEmitter.on(events_2.CLIENT_EVENTS.SUBSCRIPTION_FAILED, () => reject(new Error("Subscription Failed: " + this.name)));
        });
    }
    bind(event, handler) {
        if (handler !== undefined) {
            this.eventEmitter.on(event, handler);
            return;
        }
        return new Promise((resolve) => this.eventEmitter.on(event, resolve));
    }
    unbind(event, handler) {
        if (handler !== undefined) {
            this.eventEmitter.off(event, handler);
            return;
        }
        throw new Error("unbind is not supported with the promise-based interface");
    }
    bindAll(handler) {
        if (handler !== undefined) {
            this.eventEmitter.on(INTERNAL_ALL_EVENTS, handler);
            return;
        }
        return new Promise((resolve) => this.eventEmitter.on(INTERNAL_ALL_EVENTS, resolve));
    }
    unbindAll(handler) {
        if (handler !== undefined) {
            this.eventEmitter.off(INTERNAL_ALL_EVENTS, handler);
            return;
        }
        throw new Error("unbindAll is not supported with the promise-based interface");
    }
    resetAllBindings() {
        this.eventEmitter.removeAllListeners();
    }
    subscribe() {
        this.subscriptionAttempted = true;
        this.subscriptionPending = true;
        return this.liquidTap.sendEvent(events_2.SERVER_EVENTS.UP.SUBSCRIBE, {
            channel: this.name,
            payload: this.subPayload,
        }, this.name);
    }
    unsubscribe() {
        if (!this.unsubscribed) {
            this.subscribed = false;
            this.unsubscribed = true;
            this.subscriptionCancelled = true;
            this.subscriptionAttempted = false;
            this.resetAllBindings();
            this.liquidTap.removeChannel(this.name);
            return this.liquidTap.sendEvent(events_2.SERVER_EVENTS.UP.UNSUBSCRIBE, {
                channel: this.name,
            });
        }
        return Promise.resolve();
    }
    reinstateSubscription() {
        this.subscriptionAttempted = false;
        return this.subscribe();
    }
}
exports.Channel = Channel;
